import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../../../app-routing.module';
import { NgModule } from '@angular/core';
import { GoogleEcommerceTransactionComponent } from './google-ecommerce-transaction.component';
import { ScriptHackModule } from '../script-hack/script-hack.module';
import { GooglePatternNumberFormatter } from '../../services/google-pattern-number-formatter';

@NgModule({
    declarations: [
        GoogleEcommerceTransactionComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        Angular2SocialLoginModule,
        AppRoutingModule,
        ScriptHackModule
    ],
    providers: [
        GooglePatternNumberFormatter
    ],
    bootstrap: [],
    exports: [
        GoogleEcommerceTransactionComponent
    ]
})
export class GoogleEcommerceTransactionModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/components/google-ecommerce-transaction/google-ecommerce-transaction.module.ts